(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bakkens-product-page"] && !Shopify.designMode) return;
  try {
    
  (()=>{const root=document.querySelector('[data-bb-product]');if(!root)return;const terms=root.querySelector('[data-bb-terms]');const depositButton=root.querySelector('[data-bb-deposit]');const copy=root.querySelector('[data-bb-deposit-copy]');const price=Math.round(Number(root.dataset.priceCents||0)/100);const bands=[[29999,53344464601424,8000],[49999,53344469746000,10000],[74999,53344469778768,12000],[99999,53344469811536,14000],[149999,53344469844304,16000],[199999,53344469877072,18000],[249999,53344469909840,19000],[Infinity,53344469942608,20000]];const band=bands.find(item=>price<=item[0]);const money=value=>new Intl.NumberFormat('da-DK',{style:'currency',currency:'DKK',maximumFractionDigits:0}).format(value);if(copy&&band)copy.textContent=`Depositum ${money(band[2])} · Restbeløb ${money(Math.max(0,price-band[2]))} ved afhentning`;terms?.addEventListener('change',()=>{depositButton.disabled=!terms.checked});depositButton?.addEventListener('click',async()=>{if(!band||!terms.checked)return;depositButton.disabled=true;depositButton.textContent='Åbner betaling…';try{await fetch('/cart/clear.js',{method:'POST'});const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:band[1],quantity:1,properties:{Bil:root.dataset.productTitle,'Bilens pris':money(price),Depositum:money(band[2]),'Restbeløb ved afhentning':money(Math.max(0,price-band[2])),'Reservationsvilkår accepteret':'Ja – øjeblikkelig påbegyndelse og ophør ved fuld gennemførelse'}})});if(!response.ok)throw new Error('cart');location.href='/checkout'}catch(error){depositButton.disabled=false;depositButton.textContent='Reservér bilen';alert('Der opstod en fejl. Ring gerne til os på 25 78 63 70.')}});const dialog=document.querySelector('[data-bb-lightbox]');root.querySelectorAll('[data-bb-image]').forEach(button=>button.addEventListener('click',()=>{const image=button.querySelector('img');if(!dialog||!image)return;dialog.querySelector('img').src=image.currentSrc||image.src;dialog.showModal()}));dialog?.querySelector('[data-bb-close]')?.addEventListener('click',()=>dialog.close());dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()})})();
  (()=>{const root=document.querySelector('[data-bb-product]');if(!root)return;const start=root.querySelector('[data-bb-rental-start]');const months=root.querySelector('[data-bb-rental-months]');const output=root.querySelector('[data-bb-rental-period-text]');const endField=root.querySelector('[data-bb-rental-end]');if(!start||!months||!output||!endField)return;const pad=value=>String(value).padStart(2,'0');const iso=date=>`${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}`;const today=new Date();today.setHours(0,0,0,0);start.min=iso(today);if(!start.value)start.value=iso(today);const addMonths=(date,count)=>{const day=date.getDate();const result=new Date(date.getFullYear(),date.getMonth()+count,1);const lastDay=new Date(result.getFullYear(),result.getMonth()+1,0).getDate();result.setDate(Math.min(day,lastDay));return result};const format=date=>new Intl.DateTimeFormat('da-DK',{day:'numeric',month:'long',year:'numeric'}).format(date);const update=()=>{const count=Math.max(1,parseInt(months.value,10)||1);months.value=count;if(!start.value){output.textContent='Vælg en startdato';endField.value='';return}const parts=start.value.split('-').map(Number);const from=new Date(parts[0],parts[1]-1,parts[2]);const to=addMonths(from,count);endField.value=iso(to);output.textContent=`${format(from)} – ${format(to)} · ${count} ${count===1?'måned':'måneder'}`};start.addEventListener('change',update);months.addEventListener('input',update);update()})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bakkens-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-bb-reviews]');

    roots.forEach((root) => {
      if (root.dataset.carouselReady === 'true') return;

      const track = root.querySelector('[data-bb-review-track]');
      const previous = root.querySelector('[data-bb-review-prev]');
      const next = root.querySelector('[data-bb-review-next]');
      const cards = [...track.children];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let timer;
      let restartTimer;

      for (let index = cards.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
      }
      cards.forEach((card) => track.appendChild(card));

      const cardWidth = () => {
        const firstCard = track.firstElementChild;
        if (!firstCard) return track.clientWidth;
        const styles = window.getComputedStyle(track);
        return firstCard.getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
      };

      const move = (direction) => {
        track.scrollBy({ left: direction * cardWidth(), behavior: 'smooth' });
      };

      const stop = () => {
        window.clearInterval(timer);
        timer = undefined;
      };

      const advance = () => {
        const reachedEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
        if (reachedEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else move(1);
      };

      const start = () => {
        stop();
        if (reducedMotion.matches || document.hidden || cards.length < 2) return;
        timer = window.setInterval(advance, 6000);
      };

      const restartSoon = () => {
        stop();
        window.clearTimeout(restartTimer);
        restartTimer = window.setTimeout(start, 9000);
      };

      previous?.addEventListener('click', () => { move(-1); restartSoon(); });
      next?.addEventListener('click', () => { move(1); restartSoon(); });
      root.addEventListener('pointerenter', stop);
      root.addEventListener('pointerleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', restartSoon, { passive: true });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      reducedMotion.addEventListener?.('change', start);

      root.dataset.carouselReady = 'true';
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
